import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  // json 파일을 읽어들이기 위한 function
  const requireLang = require.context('@/locales/message', true, /\.json$/)
  const messages = {}
  // json file read
  for (const file of requireLang.keys()) {
    if (file === './index.js') continue; // index.js 파일 제외
    const path = file.replace(/(\.\/|\.json$)/g, '').split('/')
    path.reduce((o, s, i) => {
      if (o[s]) return o[s]
      o[s] = i + 1 === path.length ? requireLang(file) : {}
      return o[s]
    }, messages)
  }
  return messages
}

// function locaLocalNumberFormats() {
//   const locales = require.context('@/locales/number', true, /\.json$/)
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
  
//   return messages
// }

const options = {
    locale: 'en',//store.get('app/lang'),
    fallbackLocale: 'en',
    messages: loadLocaleMessages(),
    // numberFormats: locaLocalNumberFormats()
}

export default new VueI18n(options)